import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { css } from "styled-components";

availabilityStyles.availability = {
    container: {
        css: css`
            border: 1px solid;
            width: fit-content;
        `,
    },
};